import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import React, { useMemo } from 'react'
import { LanctoCartao, bgLineGridColorDark, bgLineGridColorLight, corBgGrid } from '../../Utils/Types'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { ThemeProvider, createTheme } from '@mui/material'
import moment from 'moment'
import { Funcoes } from '../../Utils/Funcoes'

type Props = {
    lanctoCartao: LanctoCartao[],
}

interface RowData {
    id: number,
    id_user_exclusao?: number,
    dh_exclusao?: string,
    motivo_exclusao?: string,
    name_user_delete?: string
    name_cliente: string,
    name_bandeira: string,
    valor: number,
    valor_receber: number,
}

export const GridLanctoCartaoExcluido = React.memo(({ lanctoCartao }: Props) => {

    let user = useSelector(state => selectUser(state))

    const theme = createTheme({
        palette: {
            mode: user.modeDark,
            background: {
                default:
                    user.modeDark === 'light' ? '#fff' : '#475569',
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'

    const colunas = useMemo<MRT_ColumnDef<LanctoCartao>[]>(
        () => [

            {
                accessorKey: 'name_cliente', header: 'Cliente', size: 150, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData
                    return (<span>{rowData.name_cliente ? rowData.name_cliente : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'name_bandeira', header: 'Bandeira', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData
                    return (<span>{rowData.name_bandeira ? rowData.name_bandeira : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'valor', header: 'Valor', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData
                    return (<span>{rowData.valor ? Funcoes.numberFormat(rowData.valor, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'valor_receber', header: 'Valor a Receber', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData
                    return (<span>{rowData.valor_receber ? Funcoes.numberFormat(rowData.valor_receber, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'name_user_delete', header: 'Usuário de Exclusão', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData
                    return (<span>{rowData.name_user_delete ? rowData.name_user_delete : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'motivo_exclusao', header: 'Motivo de Exclusão', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData
                    return (<span>{rowData.motivo_exclusao ? rowData.motivo_exclusao : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'dh_exclusao', header: 'Data de Exclusão', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData
                    return (<span>{rowData.dh_exclusao ? moment(rowData.dh_exclusao).format('DD/MM/YYYY') : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

        ], []
    )

    const table = useMaterialReactTable({
        columns: colunas,
        data: lanctoCartao,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: false,
        enableColumnFilters: false,
        enableHiding: false,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
    })

    return (
        <>
            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table} />

            </ThemeProvider>
        </>
    )
})